module.exports = __webpack_public_path__ + "img/welcome.69686a24.png";